module.exports = __webpack_public_path__ + "img/pr-4.eeef1fff.png";